import {ReactSelectOpt} from '@pluto/select';

export const UnassignedUser: ReactSelectOpt = {
    label: 'Unassigned',
    value: 'null',
};
